export default __webpack_public_path__ + "static/media/intro2.0ce2a975.mp4";